/*@flow*/
import React, { memo, useEffect } from 'react';
import isEmbedded from 'lib/isEmbedded';
import getCompanyId from 'lib/getCompanyId';
import getFiltersQuery from 'lib/getFiltersQuery';
import getDashboardId from 'lib/getDashboardId';
import GetProject from './queries/GetProject';
import SingleRecord from './SingleRecord';
import MultiRecord from './MultiRecord';
import useCachedQuery from 'lib/useCachedQuery';
import Blank from 'lib/Blank';
import same from 'lib/same';
import useError from 'lib/useError';
import * as I from 'immutable';

type PropsT = {
  options: Object,
  latlng: Leaflet$LatLng,
};

function ProjectPopup(props: PropsT) {
  const lonlat = I.getIn(props, ['options', 'lonlat'], null);
  const companyId = isEmbedded() ? undefined : getCompanyId();
  const filters = getFiltersQuery()
    .set('lonlat', lonlat)
    .set('dashboardId', getDashboardId())
    .set('companyId', companyId)
    .toJS();
  const { data = {}, loading, error } = useCachedQuery(GetProject, {
    variables: { filters },
  });
  // $FlowFixMe[incompatible-call]
  const projects = I.getIn(data, ['projects'], []) || [];

  useError(error);

  useEffect(() => {
    if (Blank.is(projects) && !loading) {
      (window.cityMap || window.districtMap).closePopup();
    }
  }, [projects, loading]);

  if (loading) {
    return (
      <div className="text-center">
        <i className="fa fa-spinner fa-spin" />
      </div>
    );
  }

  if (error) {
    return <div className="text-danger">{error.message}</div>;
  }

  if (Blank.is(projects)) {
    return null;
  }

  if (projects.length === 1) {
    const project = projects[0] || {};
    return <SingleRecord {...project} />;
  }
  return <MultiRecord records={projects} />;
}
const isEqual = (p, np) => same(p.latlng, np.latlng);
export default memo(ProjectPopup, isEqual);
